// ACTION  TYPES

import Api from '../../../helpers/Api';

export const SET_DATA_ARTISTS = 'SET_DATA_ARTISTS';
const setDataArtists = (data) => ({
    type: SET_DATA_ARTISTS,
    data,
});

export const SET_DATA_ARTISTS_SLIDER = 'SET_DATA_ARTISTS_SLIDER';
const setDataArtistsSlider = (dataArtistsSlider) => ({
    type: SET_DATA_ARTISTS_SLIDER,
    dataArtistsSlider,
});


// ACTIONS
// fetch all artist data (and filter out the slides (if not set...))
export const fetchDataArtistsIfNeeded = () => (dispatch, getState) => {
    const dataArtists = getState().artists.ArtistsAll.dataArtists;

    if (dataArtists.length < 1) {
        return Api.progressGet(dispatch, '/api/v1/getArtists/')
            .then((json) => {
                if (json.status === 'success') {
                    const myPromises = [];

                    // set the complete artist data into the store
                    myPromises.push(dispatch(setDataArtists(json.data)));

                    // check if the vertical banner images are already in the store, and if not, set them
                    let dataArtistsSlider = getState().artists.ArtistsAll.dataArtistsSlider;

                    if (dataArtistsSlider.length < 1) {
                        // Artists with vertical image
                        dataArtistsSlider = json.data.filter((item) => item.Ver != null);

                        myPromises.push(dispatch(setDataArtistsSlider(dataArtistsSlider)));
                    }

                    return Promise.all(myPromises);
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchDataArtists got error:', error);
            });
    }

    return Promise.resolve(1);
};

export const fetchArtistsSlidesIfNeeded = () => (dispatch, getState) => {
    const dataArtistsSlider = getState().artists.ArtistsAll.dataArtistsSlider;

    if (dataArtistsSlider.length < 1) {
        return Api.progressGet(dispatch, '/api/v1/artists/getSlides')
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setDataArtistsSlider(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchDataArtistsSlides got error:', error);
            });
    }

    return Promise.resolve(1);
};
